import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { LoginRequest, SessionUser } from '@travel-planner/shared';
import { ApiError, api } from '../api/client';

export const ME_KEY = ['me'] as const;

/** Current user, or null when unauthenticated (401). */
export function useMe() {
  return useQuery<SessionUser | null>({
    queryKey: ME_KEY,
    queryFn: async () => {
      try {
        return await api.get<SessionUser>('/me');
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) return null;
        throw err;
      }
    },
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
}

export function useLogin() {
  const qc = useQueryClient();
  return useMutation<SessionUser, ApiError, LoginRequest>({
    mutationFn: (input) => api.post<SessionUser>('/login', input),
    onSuccess: (user) => qc.setQueryData(ME_KEY, user),
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.post('/logout'),
    onSuccess: () => {
      qc.setQueryData(ME_KEY, null);
      qc.clear();
    },
  });
}
